module.exports = __webpack_public_path__ + "img/D201403_3.797def38.jpg";